import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, Gift, ChevronDown } from 'lucide-react';
export function BonusesSection() {
  const [expanded, setExpanded] = useState<Record<number, boolean>>({
    1: false,
    2: false,
    3: false
  });
  const toggleBonus = (id: number) => {
    setExpanded(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  return <section className="px-6 py-6 max-w-4xl mx-auto" data-id="element-27">
      <FadeIn data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2A26]" data-id="element-30">
            Y eso no es todo...
          </h2>
          <br data-id="element-31" />
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#9B4F2B]" data-id="element-32">
            Hoy también recibes estos
          </p>
          <p className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26]" data-id="element-33">
            3 BONOS EXCLUSIVOS
            <p className="text-1xl md:text-1xl font-serif font-REGULAR text-[#9B4F2B]" data-id="element-34">
              en $81 Completamente
            </p>
          </p>
          <p className="text-3xl md:text-4xl font-serif font-bold text-[#2D2A26]" data-id="element-35">
            GRATIS
          </p>
        </div>
      </FadeIn>

      {/* Bonus 1 */}
      <FadeIn delay={0.1} data-id="element-36">
        <div className="bg-white rounded-2xl border-2 border-[#4A5D3A]/20 shadow-lg overflow-hidden mb-10" data-id="element-37">
          <div className="bg-[#4A5D3A] py-3 px-6" data-id="element-38">
            <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-39">
              <div className="flex items-center gap-2" data-id="element-40">
                <Gift className="text-[#C4A265]" size={20} data-id="element-41" />
                <span className="text-[#FAF6F0] font-bold uppercase tracking-wider text-sm" data-id="element-42">
                  Bono #1
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-43">
                <span className="text-[#FAF6F0]/70 text-sm line-through" data-id="element-44">
                  $27 USD
                </span>
                <span className="bg-[#C4A265] text-[#2D2A26] font-bold px-3 py-1 rounded-full text-sm" data-id="element-45">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-46">
            <div className="flex flex-col lg:flex-row gap-8 items-start" data-id="element-47">
              <div className="lg:w-2/5 flex-shrink-0" data-id="element-48">
                <img src="https://cdn.magicpatterns.com/uploads/mz9bmDtjHP5G1TCXqPbW68/bono_1.png" alt="La Receta Exacta S.O.S." className="w-full max-w-sm mx-auto rounded-xl shadow-lg" data-id="element-49" />
              </div>

              <div className="lg:w-3/5" data-id="element-50">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2D2A26] mb-2" data-id="element-51">
                  "La Receta Exacta S.O.S."
                </h3>
                <p className="text-[#4A5D3A] font-medium mb-4" data-id="element-52">
                  Para cuando quieres preparar el protocolo rápidamente sin
                  revisar todo el libro.
                </p>

                <button onClick={() => toggleBonus(1)} className="flex items-center gap-2 text-[#4A5D3A] font-bold hover:text-[#2D2A26] transition-colors" data-id="element-53">
                  {expanded[1] ? 'Leer menos' : 'Leer más'}
                  <ChevronDown size={18} className={`transition-transform duration-300 ${expanded[1] ? 'rotate-180' : ''}`} data-id="element-54" />
                </button>

                <div className={`grid transition-all duration-500 ease-in-out ${expanded[1] ? 'grid-rows-[1fr] opacity-100 mt-6' : 'grid-rows-[0fr] opacity-0 mt-0'}`} data-id="element-55">
                  <div className="overflow-hidden min-h-0" data-id="element-56">
                    <div className="font-serif italic text-[#2D2A26]/80 space-y-3 mb-8 text-base md:text-lg leading-relaxed" data-id="element-57">
                      <p data-id="element-58">
                        Hay un error silencioso que hace que las plantas no
                        funcionen.
                      </p>
                      <p data-id="element-59">No es la planta. No eres tú.</p>
                      <p className="font-semibold not-italic text-[#9B4F2B]" data-id="element-60">
                        Es la preparación.
                      </p>
                      <p data-id="element-61">
                        Agua demasiado caliente. No tapar el recipiente.
                        Proporción incorrecta. Reposo insuficiente.
                      </p>
                      <p data-id="element-62">
                        Cualquiera de estos errores puede hacer que tu
                        manzanilla, pasiflora y lavanda no liberen los
                        compuestos que tu sistema nervioso necesita.
                      </p>
                      <p data-id="element-63">
                        Por eso creé esta guía. Para que no adivines. Para que
                        no falles. Para que esta noche sea diferente.
                      </p>
                    </div>

                    <p className="font-bold text-[#2D2A26] mb-4" data-id="element-64">
                      Dentro de este bono vas a encontrar:
                    </p>

                    <ul className="space-y-3 mb-8" data-id="element-65">
                      <li className="flex items-start gap-3" data-id="element-66">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-67" />
                        <span className="text-[#2D2A26]/80" data-id="element-68">
                          La receta exacta con manzanilla, pasiflora y lavanda
                          (cantidades en cucharaditas, orden de incorporación y
                          tiempos precisos)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-69">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-70" />
                        <span className="text-[#2D2A26]/80" data-id="element-71">
                          La temperatura correcta del agua (y cómo lograrla sin
                          termómetro)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-72">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-73" />
                        <span className="text-[#2D2A26]/80" data-id="element-74">
                          Los 7 errores más comunes que apagan el efecto y cómo
                          corregirlos en 30 segundos
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-75">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-76" />
                        <span className="text-[#2D2A26]/80" data-id="element-77">
                          La Tarjeta de Cocina S.O.S. (versión ultra resumida
                          para tener en el celular mientras preparas)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-78">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-79" />
                        <span className="text-[#2D2A26]/80" data-id="element-80">
                          El plan "Hoy a la noche": a qué hora tomarlo, qué
                          evitar antes y cómo potenciar el resultado
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-81">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-82" />
                        <span className="text-[#2D2A26]/80" data-id="element-83">
                          Checklist imprimible para hacerlo en automático, sin
                          pensar, sin dudar
                        </span>
                      </li>
                    </ul>

                    <p className="font-serif italic text-[#9B4F2B] text-base md:text-lg border-l-4 border-[#C4A265] pl-4" data-id="element-84">
                      "Porque la diferencia entre 'no me funcionó' y 'sentí la
                      diferencia desde la primera noche' suele ser un error de
                      preparación que nadie te explicó."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>

      {/* Bonus 2 */}
      <FadeIn delay={0.2} data-id="element-85">
        <div className="bg-white rounded-2xl border-2 border-[#4A5D3A]/20 shadow-lg overflow-hidden mb-10" data-id="element-86">
          <div className="bg-[#4A5D3A] py-3 px-6" data-id="element-87">
            <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-88">
              <div className="flex items-center gap-2" data-id="element-89">
                <Gift className="text-[#C4A265]" size={20} data-id="element-90" />
                <span className="text-[#FAF6F0] font-bold uppercase tracking-wider text-sm" data-id="element-91">
                  Bono #2
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-92">
                <span className="text-[#FAF6F0]/70 text-sm line-through" data-id="element-93">
                  $27 USD
                </span>
                <span className="bg-[#C4A265] text-[#2D2A26] font-bold px-3 py-1 rounded-full text-sm" data-id="element-94">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-95">
            <div className="flex flex-col lg:flex-row gap-8 items-start" data-id="element-96">
              <div className="lg:w-2/5 flex-shrink-0" data-id="element-97">
                <img src="https://cdn.magicpatterns.com/uploads/5vdfJ5Lt8LnrjgZj9NHUWD/bono_2.png" alt="Mapa de Calma Nocturna" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" data-id="element-98" />
              </div>

              <div className="lg:w-3/5" data-id="element-99">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2D2A26] mb-2" data-id="element-100">
                  "Mapa de Calma Nocturna"
                </h3>
                <p className="text-[#4A5D3A] font-medium mb-4" data-id="element-101">
                  Rutina rápida de 10 minutos para bajar revoluciones antes de
                  dormir.
                </p>

                <button onClick={() => toggleBonus(2)} className="flex items-center gap-2 text-[#4A5D3A] font-bold hover:text-[#2D2A26] transition-colors" data-id="element-102">
                  {expanded[2] ? 'Leer menos' : 'Leer más'}
                  <ChevronDown size={18} className={`transition-transform duration-300 ${expanded[2] ? 'rotate-180' : ''}`} data-id="element-103" />
                </button>

                <div className={`grid transition-all duration-500 ease-in-out ${expanded[2] ? 'grid-rows-[1fr] opacity-100 mt-6' : 'grid-rows-[0fr] opacity-0 mt-0'}`} data-id="element-104">
                  <div className="overflow-hidden min-h-0" data-id="element-105">
                    <div className="font-serif italic text-[#2D2A26]/80 space-y-3 mb-8 text-base md:text-lg leading-relaxed" data-id="element-106">
                      <p data-id="element-107">El protocolo S.O.S. le habla a tu cuerpo.</p>
                      <p className="font-semibold not-italic text-[#9B4F2B]" data-id="element-108">
                        Pero tu mente también necesita una señal de cierre.
                      </p>
                      <p data-id="element-109">
                        Porque hay noches en que te acuestas, el cuerpo está
                        agotado, pero la cabeza sigue corriendo.
                      </p>
                      <p data-id="element-110">
                        Pendientes. Conversaciones del día. Culpa. Presión.
                        Miedo.
                      </p>
                      <p data-id="element-111">Y por más que te digas "relájate"… no funciona.</p>
                      <p data-id="element-112">
                        Porque tu mente no se apaga a la fuerza. Se apaga con
                        señales claras y repetibles.
                      </p>
                      <p data-id="element-113">Por eso creé este mapa.</p>
                    </div>

                    <p className="font-bold text-[#2D2A26] mb-4" data-id="element-114">
                      Dentro de este bono vas a encontrar:
                    </p>

                    <ul className="space-y-3 mb-8" data-id="element-115">
                      <li className="flex items-start gap-3" data-id="element-116">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-117" />
                        <span className="text-[#2D2A26]/80" data-id="element-118">
                          Una rutina de 10 minutos (minuto a minuto) para bajar
                          el "modo alerta" antes de acostarte: respiración +
                          descarga mental + reset corporal + señal de cierre
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-119">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-120" />
                        <div className="text-[#2D2A26]/80" data-id="element-121">
                          <span data-id="element-122">
                            3 guiones anti-ruido mental (30–60 segundos cada
                            uno) para cortar el loop al instante, según tu tipo
                            de noche:
                          </span>
                          <ul className="mt-2 ml-4 space-y-1 text-sm" data-id="element-123">
                            <li className="text-[#2D2A26]/70" data-id="element-124">
                              • Guion 1: Para cuando no paras de preocuparte por
                              pendientes
                            </li>
                            <li className="text-[#2D2A26]/70" data-id="element-125">
                              • Guion 2: Para cuando sientes culpa por no haber
                              hecho suficiente
                            </li>
                            <li className="text-[#2D2A26]/70" data-id="element-126">
                              • Guion 3: Para cuando tu cuerpo sigue en modo
                              alerta sin razón aparente
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-127">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-128" />
                        <span className="text-[#2D2A26]/80" data-id="element-129">
                          Plan rescate de 3 minutos para las noches más
                          difíciles (cuando no tienes energía ni tiempo para los
                          10 minutos completos)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-130">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-131" />
                        <span className="text-[#2D2A26]/80" data-id="element-132">
                          Tracker de 7 noches para medir tu nivel de ruido
                          mental antes y después, y ver tu progreso en números
                          reales
                        </span>
                      </li>
                    </ul>

                    <p className="font-serif italic text-[#9B4F2B] text-base md:text-lg border-l-4 border-[#C4A265] pl-4" data-id="element-133">
                      "Porque mereces dejar de pelear con tu propia cabeza cada
                      noche."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>

      {/* Bonus 3 */}
      <FadeIn delay={0.3} data-id="element-134">
        <div className="bg-white rounded-2xl border-2 border-[#4A5D3A]/20 shadow-lg overflow-hidden" data-id="element-135">
          <div className="bg-[#4A5D3A] py-3 px-6" data-id="element-136">
            <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-137">
              <div className="flex items-center gap-2" data-id="element-138">
                <Gift className="text-[#C4A265]" size={20} data-id="element-139" />
                <span className="text-[#FAF6F0] font-bold uppercase tracking-wider text-sm" data-id="element-140">
                  Bono #3
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-141">
                <span className="text-[#FAF6F0]/70 text-sm line-through" data-id="element-142">
                  $27 USD
                </span>
                <span className="bg-[#C4A265] text-[#2D2A26] font-bold px-3 py-1 rounded-full text-sm" data-id="element-143">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-144">
            <div className="flex flex-col lg:flex-row gap-8 items-start" data-id="element-145">
              <div className="lg:w-2/5 flex-shrink-0" data-id="element-146">
                <img src="https://cdn.magicpatterns.com/uploads/3YecQ3mTYZ1bAtnbgHwPWe/bono_3.png" alt="Botiquín de Emergencia 2:00 AM" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" data-id="element-147" />
              </div>

              <div className="lg:w-3/5" data-id="element-148">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2D2A26] mb-2" data-id="element-149">
                  "Botiquín de Emergencia 2:00 AM"
                </h3>
                <p className="text-[#4A5D3A] font-medium mb-4" data-id="element-150">
                  Qué hacer cuando despiertas a las 2:00 AM con la mente
                  acelerada.
                </p>

                <button onClick={() => toggleBonus(3)} className="flex items-center gap-2 text-[#4A5D3A] font-bold hover:text-[#2D2A26] transition-colors" data-id="element-151">
                  {expanded[3] ? 'Leer menos' : 'Leer más'}
                  <ChevronDown size={18} className={`transition-transform duration-300 ${expanded[3] ? 'rotate-180' : ''}`} data-id="element-152" />
                </button>

                <div className={`grid transition-all duration-500 ease-in-out ${expanded[3] ? 'grid-rows-[1fr] opacity-100 mt-6' : 'grid-rows-[0fr] opacity-0 mt-0'}`} data-id="element-153">
                  <div className="overflow-hidden min-h-0" data-id="element-154">
                    <div className="font-serif italic text-[#2D2A26]/80 space-y-3 mb-8 text-base md:text-lg leading-relaxed" data-id="element-155">
                      <p data-id="element-156">Hay un momento que nadie menciona.</p>
                      <p className="font-semibold not-italic text-[#9B4F2B]" data-id="element-157">
                        Las 2:00 AM.
                      </p>
                      <p data-id="element-158">Te dormiste. Todo iba bien.</p>
                      <p data-id="element-159">Y de repente… estás despierta.</p>
                      <p data-id="element-160">
                        El corazón inquieto. La mente encendida. Los
                        pensamientos en loop.
                      </p>
                      <p data-id="element-161">Y lo peor: agarras el celular "solo un segundo"…</p>
                      <p data-id="element-162">…y ya perdiste la noche.</p>
                      <p data-id="element-163">
                        Este bono es tu kit de emergencia para ese momento
                        exacto.
                      </p>
                      <p data-id="element-164">No para "pensar positivo". No para "respirar y ya".</p>
                      <p data-id="element-165">
                        Para tener un protocolo físico de 5 minutos que le envía
                        a tu cuerpo la señal que necesita para volver a la calma
                        cuando más lo necesitas.
                      </p>
                    </div>

                    <p className="font-bold text-[#2D2A26] mb-4" data-id="element-166">
                      Dentro de este bono vas a encontrar:
                    </p>

                    <ul className="space-y-3 mb-8" data-id="element-167">
                      <li className="flex items-start gap-3" data-id="element-168">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-169" />
                        <span className="text-[#2D2A26]/80" data-id="element-170">
                          Protocolo Express de 5 minutos (posición + respiración
                          4–2–8 + reset muscular + guion) diseñado
                          específicamente para el despertar nocturno
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-171">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-172" />
                        <div className="text-[#2D2A26]/80" data-id="element-173">
                          <span data-id="element-174">
                            3 guiones de rescate (30–45 segundos) para cortar el
                            loop dependiendo de qué te despertó:
                          </span>
                          <ul className="mt-2 ml-4 space-y-1 text-sm" data-id="element-175">
                            <li className="text-[#2D2A26]/70" data-id="element-176">
                              • Preocupación / loop mental
                            </li>
                            <li className="text-[#2D2A26]/70" data-id="element-177">
                              • Culpa o autoexigencia
                            </li>
                            <li className="text-[#2D2A26]/70" data-id="element-178">
                              • Alerta o hipervigilancia
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-179">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-180" />
                        <span className="text-[#2D2A26]/80" data-id="element-181">
                          La Tarjeta de Mesita de Noche (checklist ultra
                          resumido para tener a mano sin buscar nada en la
                          oscuridad)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-182">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-183" />
                        <span className="text-[#2D2A26]/80" data-id="element-184">
                          Qué hacer si no te dormiste en 15 minutos (sin
                          celular, sin luz fuerte, sin entrar en pánico)
                        </span>
                      </li>
                      <li className="flex items-start gap-3" data-id="element-185">
                        <Check className="text-[#4A5D3A] mt-1 flex-shrink-0" size={20} data-id="element-186" />
                        <span className="text-[#2D2A26]/80" data-id="element-187">
                          Tracker de despertares 7 días para ver en números
                          reales cuánto mejoran tus noches semana a semana
                        </span>
                      </li>
                    </ul>

                    <p className="font-serif italic text-[#9B4F2B] text-base md:text-lg border-l-4 border-[#C4A265] pl-4" data-id="element-188">
                      "Porque la noche no es para resolver tu vida. Es para
                      recuperar tu cuerpo."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}